'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AdresaApi = require('./../api/gen/adresy/AdresaApi');

var _AdresaApi2 = _interopRequireDefault(_AdresaApi);

var _StoreSuggestField = require('./StoreSuggestField');

var _StoreSuggestField2 = _interopRequireDefault(_StoreSuggestField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Field pro výběr státu.
 */
var StatField = function (_React$Component) {
    (0, _inherits3.default)(StatField, _React$Component);

    function StatField() {
        (0, _classCallCheck3.default)(this, StatField);
        return (0, _possibleConstructorReturn3.default)(this, (StatField.__proto__ || (0, _getPrototypeOf2.default)(StatField)).apply(this, arguments));
    }

    (0, _createClass3.default)(StatField, [{
        key: 'render',
        value: function render() {
            var showKod = this.props.showKod;


            return _react2.default.createElement(_StoreSuggestField2.default, (0, _extends3.default)({
                apiCall: function apiCall() {
                    return _AdresaApi2.default.getStaty();
                },
                inputProps: { placeholder: "Stát" },
                area: 'shared.statField',
                getItemId: function getItemId(item) {
                    return item ? item.kodA3 : null;
                },
                getItemName: function getItemName(item) {
                    return item ? showKod ? item.kodA3 + ' (' + item.nazev + ')' : item.nazev : "";
                }
            }, this.props));
        }
    }]);
    return StatField;
}(_react2.default.Component);

exports.default = StatField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvZmllbGQvU3RhdEZpZWxkLmpzeCJdLCJuYW1lcyI6WyJTdGF0RmllbGQiLCJzaG93S29kIiwicHJvcHMiLCJBZHJlc2FBcGkiLCJnZXRTdGF0eSIsInBsYWNlaG9sZGVyIiwiaXRlbSIsImtvZEEzIiwibmF6ZXYiLCJSZWFjdCIsIkNvbXBvbmVudCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7Ozs7QUFFQTs7O0lBR01BLFM7Ozs7Ozs7Ozs7aUNBRU87QUFBQSxnQkFDRUMsT0FERixHQUNhLEtBQUtDLEtBRGxCLENBQ0VELE9BREY7OztBQUdMLG1CQUFPLDhCQUFDLDJCQUFEO0FBQ0gseUJBQVM7QUFBQSwyQkFBTUUsb0JBQVVDLFFBQVYsRUFBTjtBQUFBLGlCQUROO0FBRUgsNEJBQVksRUFBQ0MsYUFBYSxNQUFkLEVBRlQ7QUFHSCxzQkFBSyxrQkFIRjtBQUlILDJCQUFXO0FBQUEsMkJBQVFDLE9BQU9BLEtBQUtDLEtBQVosR0FBb0IsSUFBNUI7QUFBQSxpQkFKUjtBQUtILDZCQUFhO0FBQUEsMkJBQVFELE9BQVFMLFVBQWFLLEtBQUtDLEtBQWxCLFVBQTRCRCxLQUFLRSxLQUFqQyxTQUE0Q0YsS0FBS0UsS0FBekQsR0FBa0UsRUFBMUU7QUFBQTtBQUxWLGVBTUMsS0FBS04sS0FOTixFQUFQO0FBUUg7OztFQWJtQk8sZ0JBQU1DLFM7O2tCQWdCZlYsUyIsImZpbGUiOiJTdGF0RmllbGQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBBZHJlc2FBcGkgZnJvbSAnLi8uLi9hcGkvZ2VuL2FkcmVzeS9BZHJlc2FBcGknO1xuaW1wb3J0IFN0b3JlU3VnZ2VzdEZpZWxkIGZyb20gXCIuL1N0b3JlU3VnZ2VzdEZpZWxkXCI7XG5cbi8qKlxuICogRmllbGQgcHJvIHbDvWLEm3Igc3TDoXR1LlxuICovXG5jbGFzcyBTdGF0RmllbGQgZXh0ZW5kcyBSZWFjdC5Db21wb25lbnQge1xuXG4gICAgcmVuZGVyKCkge1xuICAgICAgICBjb25zdCB7c2hvd0tvZH0gPSB0aGlzLnByb3BzO1xuXG4gICAgICAgIHJldHVybiA8U3RvcmVTdWdnZXN0RmllbGRcbiAgICAgICAgICAgIGFwaUNhbGw9eygpID0+IEFkcmVzYUFwaS5nZXRTdGF0eSgpfVxuICAgICAgICAgICAgaW5wdXRQcm9wcz17e3BsYWNlaG9sZGVyOiBcIlN0w6F0XCJ9fVxuICAgICAgICAgICAgYXJlYT1cInNoYXJlZC5zdGF0RmllbGRcIlxuICAgICAgICAgICAgZ2V0SXRlbUlkPXtpdGVtID0+IGl0ZW0gPyBpdGVtLmtvZEEzIDogbnVsbH1cbiAgICAgICAgICAgIGdldEl0ZW1OYW1lPXtpdGVtID0+IGl0ZW0gPyAoc2hvd0tvZCA/IGAke2l0ZW0ua29kQTN9ICgke2l0ZW0ubmF6ZXZ9KWAgOiBpdGVtLm5hemV2KSA6IFwiXCJ9XG4gICAgICAgICAgICB7Li4udGhpcy5wcm9wc31cbiAgICAgICAgLz47XG4gICAgfVxufVxuXG5leHBvcnQgZGVmYXVsdCBTdGF0RmllbGQ7XG4iXX0=